import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../Redux/Store/Hooks';
import { updateFixtureOrder } from '../../Redux/Slicers/Fixtures/UpdateFixtureOrderSlicer';
import ResponseDialog from '../../Components/ResponseDialog/ResponseDialog';

interface Item {
  fixture_id: string;
  spaceCount: number;
  fixture_ip_address: string;
  index: number;
}

interface TableProps {
  rows: Item[];
  columns: string[];
}

const FixtureOrder: React.FC<any> = ({ rows, onSubmit }) => {
  const dispatch = useAppDispatch();
  const [items, setItems] = useState<Item[]>(rows);
  const [draggedIndex, setDraggedIndex] = useState<number | null>(null);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const { data: updateFixtureOrders } = useAppSelector(
    (state: any) => state?.UpdateFixtureOrder
  );
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    setOpen(true);
    console.log(updateFixtureOrders);
  }, [updateFixtureOrders]);
  //   console.log(updateFixtureOrders);

  // Handle drag start
  const handleDragStart = (index: number) => {
    setDraggedIndex(index);
  };

  // Allow drop
  const handleDragOver = (e: React.DragEvent<HTMLTableRowElement>) => {
    e.preventDefault();
  };

  // Handle drop event
  const handleDrop = (index: number) => {
    if (draggedIndex === null || draggedIndex === index) return;

    const updatedItems = [...items];
    const [draggedItem] = updatedItems.splice(draggedIndex, 1);
    updatedItems.splice(index, 0, draggedItem);

    const reorderedItems = updatedItems.map((item, idx) => ({
      ...item,
      order: idx + 1,
    }));

    setItems(reorderedItems);
    setDraggedIndex(null);
  };

  // Handle row click to select the item
  const handleRowClick = (index: number) => {
    setSelectedIndex(index);
  };

  const handleButtonClick = () => {
    // setOpen(true);
    dispatch(updateFixtureOrder(items));
    console.log(items);
  };

  return (
    <>
      <div>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                Fixture ID
              </th>
              <th style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                Space Count
              </th>
              <th style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                IP Address
              </th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr
                key={item.index}
                draggable
                onDragStart={() => handleDragStart(index)}
                onDragOver={handleDragOver}
                onDrop={() => handleDrop(index)}
                onClick={() => handleRowClick(index)}
                style={{
                  cursor: 'move',
                  backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff', // Highlight selected row
                }}>
                <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                  {item.fixture_id}
                </td>
                <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                  {item.spaceCount}
                </td>
                <td style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
                  {item.fixture_ip_address}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Button
          className="add_button"
          onClick={handleButtonClick}
          style={{ marginTop: '10px', width: '113px', marginLeft: '100px' }}>
          Submit
        </Button>
      </div>
    </>
  );
};

export default FixtureOrder;
